import {
  ChartPie,
  FileChartPie,
  PersonStanding,
  type LucideIcon,
} from 'lucide-react';
import { eyeAbleUrlMapping } from '@helpers/constants';
import ProductCard from './ProductCard';

type ProductTile = {
  icon: LucideIcon;
  id: string;
  learnMoreLink: keyof typeof eyeAbleUrlMapping;
  link: string;
  name: string;
};

const PRODUCTS: ProductTile[] = [
  {
    id: 'assist',
    name: 'Assist',
    link: '/assist',
    icon: PersonStanding,
    learnMoreLink: 'EAassist',
  },
  {
    id: 'audit',
    name: 'Audit',
    link: '/audit',
    icon: ChartPie,
    learnMoreLink: 'EAaudit',
  },
  {
    id: 'report',
    name: 'Report',
    link: '/report/overview',
    icon: FileChartPie,
    learnMoreLink: 'EAreport',
  },
];

function ProductCards() {
  return (
    <div className='eye:grid eye:grid-cols-1 eye:gap-m eye:sm:grid-cols-2 eye:xl:grid-cols-3'>
      {PRODUCTS.map((product) => {
        return (
          <ProductCard
            key={product.id}
            product={product.name}
            link={product.link}
            icon={product.icon}
            learnMoreLink={product.learnMoreLink}
          />
        );
      })}
    </div>
  );
}

export default ProductCards;
